import {Component} from "@angular/core";

@Component({
    selector: 'tfl-card-transfer-icon',
    template: require('./card.transfer.icon.html')
})
export class CardTransferIcon {

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/icons/card/card.transfer.icon.ts